import {Component, Vue} from "vue-property-decorator";


@Component
export default class SubViewJumper extends Vue {
    vpcId: string = ''

    saveVpcId() {
        localStorage.vpcId = this.vpcId;
    }

    go(url:string, toSelf:boolean = false, saveVpcId:boolean = true) {
        if (saveVpcId) {
            this.saveVpcId();
        }
        window.open(url,  toSelf ? '_self' : '_blank');
    }

    go2subnet(targetSelf?:boolean) {
        this.go('/v2/#/vpc/subnet', targetSelf)
    }
    go2route(targetSelf?:boolean) {
        this.go('/v2/#/vpc/route', targetSelf)
    }

    go2evif(targetSelf?:boolean) {
        this.go('/v2/#/vpc/evif', targetSelf)
    }

    go2evifWithSubnetId(subnetId:string, targetSelf?:boolean) {
        localStorage.evifSubnetID = subnetId;
        this.go('/v2/#/vpc/evif', targetSelf)
    }

    go2routeTable(targetSelf?:boolean) {
        this.go('/#!/vpc/route-table', targetSelf)
    }
    go2nat(targetSelf?:boolean) {
        this.go('/#!/vpc/natIndex', targetSelf)
    }
    go2peering(targetSelf?:boolean) {
        this.go('/#!/vpc/connectIndex', targetSelf)
    }
    go2vpn(targetSelf?:boolean) {
        this.go('/v2/#/vpn/vpnsub', targetSelf)
    }
    go2slb(targetSelf?:boolean) {
        this.go('/#!/slb/slbIndex', targetSelf)
    }
    go2alb(targetSelf?:boolean) {
        this.go('/#!/slb/apply-slb', targetSelf)
    }
    go2brsg(targetSelf?:boolean) {
        this.go('/#!/slb/apply-server', targetSelf)
    }
    go2pdns(targetSelf?:boolean) {
        this.go('/v2/#/pdns/instance', targetSelf)
    }
    go2sg(targetSelf?:boolean) {
        this.go('/#!/vpc/group', targetSelf)
    }
    go2acl(targetSelf?:boolean) {
        this.go('/#!/vpc/acl', targetSelf)
    }
}

